<template>
  <div>
    <div class="box" id="box" ref="box">
      <h1>基础设施安全情况播报</h1>

      <vue-seamless-scroll :data="bug" class="warp" :class-option="classOption">
        <ul>
          <li v-for="(item, index) in bug" :key="index">
            <span class="date">{{dealDate(item.date)}}</span>
            <span :class="item.source == '威胁情报'?'theatre':'test'">{{item.source}}</span>
            <div class="notice">
              <span>
                {{item.content}}
              </span>
            </div>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>
<script>
import {getSecurityBroadcast} from "@/service/dashboard";
import vueSeamlessScroll from "vue-seamless-scroll";
export default {
  components: {
    vueSeamlessScroll
  },
  data() {
    return {
      bug:[{date:"2024-5-19",name:"xx单位", source:"威胁情报", content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-17",name:"xx单位", source:"威胁情报",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-16",name:"xx单位", source:"监测平台",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）" },
        {date:"2024-5-15",name:"xx单位", source:"威胁情报",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-13",name:"xx单位", source:"威胁情报",   content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-11",name:"xx单位", source:"监测平台",   content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）" },
        {date:"2024-5-16",name:"xx单位", source:"监测平台",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）" },
        {date:"2024-5-15",name:"xx单位", source:"威胁情报",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-13",name:"xx单位", source:"威胁情报",   content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-11",name:"xx单位", source:"监测平台",   content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）" },
        {date:"2024-5-16",name:"xx单位", source:"监测平台",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）" },
        {date:"2024-5-15",name:"xx单位", source:"威胁情报",  content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-13",name:"xx单位", source:"威胁情报",   content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）"},
        {date:"2024-5-11",name:"xx单位", source:"监测平台",   content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）" },
        {date:"2024-5-8",name:"xx单位", source:"监测平台",   content:"WordPress Bricks Builder远程代码执行漏洞（CVE-2024-25600）" }],
      classOption: {
        step: 1,
        singleHeight:0.25 ,
        waitTime: 3000,
        isSingleRemUnit: true

      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      getSecurityBroadcast().then(res => {
        this.bug = res;
      });
    },
    dealDate(isoDateString){
      let date = new Date(isoDateString);

      let year = date.getFullYear();

      let month = (date.getMonth() + 1).toString().padStart(2, "0"); // 月份从 0 开始，所以需要 +1

      let day = date.getDate().toString().padStart(2, "0");

      return `${year}-${month}-${day}`;
    }
  }
};


</script>
<style scoped  lang="less">
.box {
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  width: 430px;
  height: 422px;
  border-radius: 10px;
  position: relative;
}
h1{
  color: rgba(241, 237, 255, 1);
  font-family: 'YouSheBiaoTiHei';
  font-size: 24px;
  height: 31px;
  position: absolute;
  left: 36px;
  top: 15px;
  text-shadow: 0 2px 20px rgba(42, 56, 180, 1) ;
}
.warp {
  position: absolute;
  left: 18px;
  top: 58px;
  height: 335px;
  font-family: AlibabaRegular;
  overflow: hidden;
}

ul li{
  list-style-type: none; /* 去除项目符号 */
  width: 383px;
  height: 48px;
  line-height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:0 7px;
  box-sizing: border-box;
  color: #fff;
}

li:nth-of-type(odd){
  background: url("../../assets/PlatformOverview/textBackground.png") no-repeat;
  background-size: 100%;
}
li .date{
  width: 85px;
}
li .test{
  width: 81px;
  color: rgba(159, 158, 242, 1);
}
li .theatre{
  width: 81px;
  color: rgba(244, 191, 54, 1);
}
li .notice{
  width: 185px;
  height: 48px;
  color: #fff;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  span{
    line-height: 14px;
    font-family: AlibabaRegular;
  }
}


</style>